import { z } from "zod";

export const userSchema = z.object({
	id: z.string().uuid(),
	email: z.string().email().nullable(),
	phone: z.string().nullable(),
	full_name: z.string().min(1),
	preferred_language: z.enum(["ar", "en"]).default("ar"),
	preferred_calendar: z.enum(["gregorian", "hijri"]).default("gregorian"),
	preferred_number_format: z
		.enum(["arabic-indic", "western"])
		.default("arabic-indic"),
	totp_enabled: z.boolean(),
	is_email_verified: z.boolean(),
	is_phone_verified: z.boolean(),
	avatar_url: z.string().url().nullable(),
	last_seen_at: z.string().datetime().nullable(),
	created_at: z.string().datetime(),
	updated_at: z.string().datetime(),
});
export type User = z.infer<typeof userSchema>;

export type AuthenticatedUser = User & {
	clinic_id: string;
	role: import("./role.ts").Role;
};
